import React, { useEffect, useState } from 'react'
import { get } from '../../util/request';
import { useSelector } from 'react-redux';
import { format } from 'date-fns';

const Notification = () => {
  const [showModal, setShowModal] = useState(false);
  const [state, setState] = useState({
    notificationList: '',
    notificationDetail: '',
    idNotification: '',
    profile: '',
    form: {
      employee_id: '',
      company_id: '',
    },
    avatar: '',
    fileAvatar: '',
    attendanceSummary: '',
    filter: 'all',
    loading: true
  })

  const jwtToken = useSelector(state => state.auth.generateToken)
  const user = useSelector(state => state.auth.user)

  useEffect(() => {
    let isMounted = true
    if (isMounted) {
      getNotificationList()
    }
    return () => isMounted === false
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.filter])

  const getNotificationList = (url) => {
    get(
      `public/api/v1/notification-list?companyId=${user.company_id}&employeeId=${user.employee_id}`,
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          'Content-Type': 'application/json'
        },
      },
      success => {
        setState({
          ...state,
          notificationList: success.data.Data,
          loading: false
        })

      },
      error => {
        setState(prevState => {
          return {
            ...prevState,
            loading: false
          }
        })
        console.log('error request', error)
      }
    )
  }

  const handleReadNotification = (e, id) => {
    get(
      `public/api/v1/notification-read-one?companyId=${user.company_id}&employeeId=${user.employee_id}&notificationId=` + id,
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          'Content-Type': 'application/json'
        },
      },
      success => {
        setState({
          ...state,
          // notificationList: success.data.Data,
          loading: true
        })
        setShowModal(e)

        getNotificationList()


      },
      error => {
        setState(prevState => {
          return {
            ...prevState,
            loading: false
          }
        })
        console.log('error request', error)
      }
    )
  }

  const handleModal = (e, id) => {
    setShowModal(e)
    var detail = state.notificationList.find(x => x.notification_id === id)
    setState({
      ...state,
      notificationDetail: detail,
      id: id
    })
  }

  const formatDate = (date) => {
    const dt1 = new Date(date);
    var d1 = format(dt1, 'p')
    return d1
  }

  return (
    state.loading ? "" :
      <div className='w-full h-screen grid-cols-1 sm:grid-cols-2 bg-bg-primary'>
        <div className='w-full h-20 bg-real-white'>
          <div className='flex items-center h-full px-4'>
            <a href={process.env.PUBLIC_URL + "/home"}>
              <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/arrow-left.svg"} className='justify-start w-10 py-1' />
            </a>
            <p className='px-4'>Notification</p>
          </div>
        </div>
        <div>

          <div className='grid grid-cols-1'>
            {state.notificationList.map((item, index) => (
              <div onClick={() => handleModal(true, item.notification_id)} className="flex items-center p-4 mx-4 mt-4 bg-white border-b border-gray-300 rounded-lg" style={{ backgroundColor: item.read ? '#F2F2F2' : 'white' }} key={index}>
                <div className='pr-4'>
                  <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/notif.svg"} className='justify-start w-4 m-auto' />
                </div>
                <div className='w-full'>
                  <div className='flex justify-between'>
                    <p className='text-base font-bold'>{item.notification_title}</p>
                    <p className='text-base'>{formatDate(item.created_at)}</p>
                  </div>
                  <div className='flex justify-between'>
                    <div>
                      <p className=''>{item.notification_less_content}</p>
                      <p className='text-xs'>{item.notification_date}</p>
                    </div>
                    <div>
                      {/* <img alt='logo_home' src={item.notification_image == null ? process.env.PUBLIC_URL + "/assets/img/checklist.svg" : process.env.PUBLIC_URL + "/assets/img/" + item.notification_image} className='h-6 text-center ' /> */}

                      {item.notification_image == null ? '' :
                        <img alt='logo_home' src={item.notification_image} className='h-6 text-center ' />}
                    </div>
                  </div>
                </div>

              </div>
            ))}

          </div>

          {showModal ? (
            <>
              <div
                className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none"
              >
                <div className="relative w-3/4 max-w-3xl mx-auto my-6">
                  {/*content*/}
                  <div className="relative flex flex-col w-full bg-white border-0 rounded-lg shadow-lg outline-none focus:outline-none">
                    {/*body*/}
                    <div className="relative flex-auto p-6">
                      <div>
                        <p className='pt-4 pb-2 font-bold'>{state.notificationDetail?.notification_title}</p>
                        <p className=''><div dangerouslySetInnerHTML={{ __html: state.notificationDetail?.notification_content }} /></p>
                      </div>
                    </div>
                    {/*footer*/}
                    <div className="flex items-center justify-end p-6 border-t border-solid rounded-b border-blueGray-200">
                      <button
                        className="px-6 py-2 mb-1 mr-1 text-sm font-bold uppercase transition-all duration-150 ease-linear outline-none text-grey-500 background-transparent focus:outline-none"
                        type="button"
                        onClick={() => handleReadNotification(false, state.notificationDetail?.notification_id)}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="fixed inset-0 z-40 bg-black opacity-25"></div>
            </>
          ) : null}
        </div>




      </div >
  )
}

export default Notification